module.exports = __webpack_public_path__ + "img/hosheh_yes.67fe5af2.png";